import axiosInstance from "../../axios/axiosInstance";
import { CREATE_HEADER_TEMPLATE, DELETE_HEADER_TEMPLATE, DELETE_TEMPLATE, EDIT_HEADER_TEMPLATE, HEADER_LISTING, HEADER_TEMPLATE_SINGLE_LISTING, STATUS_UPDATE_HEADER } from "../../constants";



export const createHeaderTemplate = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_HEADER_TEMPLATE, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const editHeaderTemplate = (id, values) => onResponse => {
    try {
        axiosInstance.put(`${EDIT_HEADER_TEMPLATE}/${id}`, values)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        console.error('Error in editTemplate:', error);
    }
};

export const getHeaderListing = ({ skip, limit, search }) => onResponse => {
    const BASE_URL = `${HEADER_LISTING}?skip=${skip}&limit=${limit}&search=${search}`;
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getHeaderTemplateDetails = (id) => (onResponse) => {
    try {
        axiosInstance
            .get(HEADER_TEMPLATE_SINGLE_LISTING + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) { }
};

export const statusUpdateHeader = (id) => onResponse => {

    try {
        axiosInstance.put(STATUS_UPDATE_HEADER + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const deleteHeaderTemplate = (id) => onResponse => {

    try {
        axiosInstance.delete(DELETE_HEADER_TEMPLATE + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
